import React from "react";
import styled from "styled-components";

const PageStyle = styled.div`
    width: 100%;
    height: 100%;
`;

export const Page = ({ children }) =>
    <PageStyle>
        {children}
    </PageStyle>;